import { IMatter } from './matter';
import { IMatterRequest } from './matterRequest';
import { IPrincipalCompany } from './principalCompany';
import { IPrincipalPrivatePerson } from './principalPrivatePerson';
import { ITranslations } from './transactionTypes';
import { IUser } from './user';

export enum IdentificationFilters {
  NOT_STARTED = 'not-started',
  STARTED = 'started',
  DONE = 'done',
}
export enum CustomerIdentificationStatus {
  NOT_STARTED = 'not-started',
  STARTED = 'started',
  DONE = 'done',
}

export enum CustomerIdentificationLevel {
  NOT_NEEDED = 'not-needed',
  SIMPLIFIED = 'simplified',
  STANDARD = 'standard',
  ENHANCED = 'enhanced',
}

export interface ICustomerIdentification {
  id: string;
  status: CustomerIdentificationStatus;
  level: CustomerIdentificationLevel;
  levelReason?: string;
  identifiedOn?: string;
  startedOn: string;
  reviewedOn?: string;
  otherInformation?: string;
  companyId: string;
  contactPersonId?: string;
  matterId?: string;
  matterRequestId?: string;
  assistantUserId?: string;
  responsibleUserId: string;
  identifiedByUserId?: string;
  reviewedByUserId?: string;
  linkedCompanyIdentificationId?: string;
  riskAssessmentId: string;
  company?: IPrincipalCompany;
  privatePersonId?: string;
  privatePerson: IPrincipalPrivatePerson;
  contactPerson?: IPrincipalPrivatePerson;
  matter?: IMatter;
  matterRequest?: IMatterRequest;
  assistantUser?: IUser;
  responsibleUser?: IUser;
  identifiedByUser?: IUser;
  reviewedByUser?: IUser;
  linkedCompanyIdentification?: ICustomerIdentification;
  riskAssessment?: ICustomerIdentificationRiskAssessment;
}
export interface ICustomerIdentificationRiskAssessment {
  validityDurationInMonths: number;
  showExpirationWarning: boolean;
  translations: ITranslations[];
  status: string;
  description: string;
  name: string;
}
